
<template>
  <div class="indexCont">
    <banner></banner>
    <div class="main-cont flex-lay-row wrap part0">
      <div class="img">
        <i></i>
      </div>
      <div class="flex-lay-column mt20">
        <title-content :msgObj="titleObj0"></title-content>
        <router-link class="more" to="/serviceProject">MORE</router-link>
      </div>
    </div>
    <div class="part1">
      <div class="main-cont flex-lay-row wrap">
        <div class="flex-lay-column mb20">
          <title-content :msgObj="titleObj1"></title-content>
          <router-link class="more" to="/caseShow">MORE</router-link>
        </div>
        <div class="img">
          <i></i>
        </div>
      </div>
    </div>
    <div class="main-cont part2">
      <title-content :msgObj="titleObj2"></title-content>
      <div class="img"></div>
    </div>
    <div class="part3">
      <div class="main-cont">
        <title-content :msgObj="titleObj3"></title-content>
        <div class="img">
          <i></i>
        </div>
        <ul class="flex-lay-row">
          <li v-for="(item, ind) in list0" :key="ind" :class="`item_${ind}`"> 
            <span>____</span>
            <p>{{item}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="part4">
      <title-content :msgObj="titleObj4"></title-content>
    </div>
  </div>
</template>
<script>
import banner from './banner'
export default{
  name: 'index',
  data () {
    return {
      titleObj0: {
        horizontal: 'left',
        title1: '致力于通过技术研发',
        title2: 'DAWNING TECHNOLOGY致力于通过技术研发、业务实训、平台运营三大版块打造电子商务生态系统的互联网公司。基础业务有建站业务、全景业务、营销业务为客户提供一站式智慧营销解决方案，制定互联网服务标准。'
      },
      titleObj1: {
        horizontal: 'left',
        title1: '智能营销平台',
        title2: '颠覆传统建站，为你的用户访问体验竭尽全力，强大酷炫的动效，全局适用不限组件多种风格任意挑选，精准设置实现你的创意'
      },
      titleObj2: {
        title1: '体验各种不同的风格模版',
        title2: '可申请优惠使用，体验各种不同的风格模版；更好的体验产品优势，享有各类功能，性价比高，产品稳定；每周持续更新'
      },
      titleObj3: {
        title1: '丰富的功能组件',
        title2: '丰富的功能组件，享有各类功能，性价比高，产品稳定；持续迭代更新；随心搭建你想要的网站，移动端小程序多端共享，一切只需要1分钟'
      },
      titleObj4: {
        title1: '品质如一值得信赖',
        title2: '感谢你们一路同行，我们一直在努力只为让您满意'
      },
      list0: [
        '文章编辑，分类，更新发布操作简单', '轮播多图，列表多图，魔法多图', 
        '多种动画效果，操作简单轻松设置', '制作一套模板，适用手机PC端'
      ]
    }
  },
  components: {
    banner
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.indexCont{
  .banner-cont{
    background-image: url('../../assets/dawing/ia_200000010.jpg');
  }
  .more{
    display: block;
    width: 1.6rem;
    height: 0.4rem;
    line-height: .4rem;
    background: #2b2b2b;
    color: #fff;
    text-align: center;
    margin-top: .3rem;
  }
  .part2{
    .img{
      margin-top: .5rem;
      // width: 40%;
      height: 5.4rem;
      background: url('../../assets/dawing/ia_300000010.png') no-repeat center;
      background-size: contain;
    }
  }
  .part0, .part1{
    .flex-lay-column{
      align-items: flex-start;
      max-width: 90%;
    }
    .img{
      width: 6rem;
      flex-shrink: 0;
      height: 4.3rem;
      position: relative;
      background: url('../../assets/dawing/ia_500000013.png') no-repeat left 1rem center;
      background-size: contain;
      i{
        position: absolute;
        width: 1.25rem;
        height: 2rem;
        right: 1.3rem;
        bottom: .8rem;
        background: url('../../assets/dawing/num_01.png') no-repeat center;
        background-size: contain;
      }
    }
  }
  .part1{
    background: #f8f8f8;
    .img{
      width: 7rem;
      height: 4.3rem;
      background: url('../../assets/dawing/ia_500000015.png') no-repeat left 1rem center;
      background-size: contain;
      i{
        left: 1rem;
        top: 1rem;
        background: url('../../assets/dawing/num_02.png') no-repeat center;
        background-size: contain;
      }
    }
  }
  .part3{
    background: #222;
    .mainTitle{
      /deep/ span, /deep/ .subtitle{
        color: #aaa;
      }
      /deep/ .title{
        color: #ccc;
      }
    }
    .img{
      margin: .3rem auto;
      width: 7rem;
      height: 4rem;
      position: relative;
      background: url('../../assets/dawing/ia_500000018.png') no-repeat center;
      i{
        position: absolute;
        width: 1.25rem;
        height: 2rem;
        right: -.3rem;
        bottom: .8rem;
        background: url('../../assets/dawing/num_03.png') no-repeat center;
        background-size: contain;
      }
    }
    ul{
      align-items: flex-start;
      margin-top: .4rem;
    }
    li{
      @extend .flex-lay-column;
      flex: 1;
      i{
        width: .52rem;
        height: .5rem;
        display: block;
        margin-top: .8rem;
        margin-bottom: .2rem;
      }
      p{
        width: 75%;
        margin: .2rem auto;
        text-align: center;
        line-height: .3rem;
        color: #aaa;
      }
      span{
        color: #aaa;
      }
    }
  }
}
@for $i from 0 to 5{
  .part#{$i} {
    padding: 1.3rem 0;
  }
}
@media (max-width: 700px)  {
  
}
</style>


// WEBPACK FOOTER //
// src/components/DAWNING/index.vue